module.exports = __webpack_public_path__ + "img/NewsSocietyBanner.3590a46f.png";